import { render, staticRenderFns } from "./CompressList.vue?vue&type=template&id=294a71c0&scoped=true&"
import script from "./CompressList.vue?vue&type=script&lang=ts&"
export * from "./CompressList.vue?vue&type=script&lang=ts&"
import style0 from "./CompressList.vue?vue&type=style&index=0&id=294a71c0&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "294a71c0",
  null
  
)

export default component.exports